"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMapsEndpoints = createMapsEndpoints;
/**
 * Etkinlik haritası (harita kapsamı 14.10.2026): herkese açık harita ayarları ve
 * organizatörün adres araması. Arama yalnız düğmeye basınca çağrılır.
 */
function createMapsEndpoints(client) {
    return {
        maps: {
            settings: () => client.call('/maps/settings', 'get', {}),
            venueSearch: (input) => client.call('/maps/venue-search', 'post', { body: input }),
        },
    };
}
//# sourceMappingURL=maps.js.map